import axios from "axios";
import { error } from "../Components/custom-toast/CustomToast";
import { t } from "i18next";

export const APIHelper = {
    postData: async function (body) {
        const configs = {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                "Access-Controller-Allow-Headers": "Content-Type",
                "Access-Control-Allow-Methods": "PUT, POST, PATCH, DELETE, GET"
            }
        }
        return await axios.post(process.env.REACT_APP_API_GW, body, configs).then(result => result.data).catch(err => {
            console.log(err);
            err.response.status;
        });
    },
    postDataBasic: async function (body) {
        const auth_base = {
            username: process.env.REACT_APP_PHL_GW_USERNAME,
            password: process.env.REACT_APP_PHL_GW_PASSWORD,
        };
        const data_head =
        {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Access-Controller-Allow-Headers": "Content-Type",
            "Access-Control-Allow-Methods": "PUT, POST, PATCH, DELETE, GET"
        }
        const axiosBase = axios.create({
            baseURL: process.env.REACT_APP_API_GW,
            headers: data_head,
            auth: auth_base,
            timeout: process.env.REACT_APP_CONNECTION_TIMEOUT
        });
        return await axiosBase.post('', body).then(result => result.data).catch(err => {
            if (err.code === 'ECONNABORTED') {
                // console.error('⏰ Request timed out');
                error(t("connectiontoolong"));
            } else if (err.response) {
                // console.error(`🚫 Error ${err.response.status}:`, err.response.data);
            } else {
                // console.error('❌ Unexpected error:', err.message);
            }
            throw err;
        });
    },

    postMultiFileBasic: async function (formData, param) {
        const auth_base = {
            username: process.env.REACT_APP_PHL_GW_USERNAME,
            password: process.env.REACT_APP_PHL_GW_PASSWORD,
        };
        const axiosBase = axios.create({
            baseURL: process.env.REACT_APP_API_UPLOAD_GW,
            auth: auth_base,
            timeout: process.env.REACT_APP_CONNECTION_TIMEOUT,
            params: param,
        });
        return await axiosBase.post('', formData).then(result => result.data).catch(err => {
            if (err.code === 'ECONNABORTED') {
                // console.error('⏰ Request timed out');
                error(t("connectiontoolong"));
            } else if (err.response) {
                // console.error(`🚫 Error ${err.response.status}:`, err.response.data);
            } else {
                // console.error('❌ Unexpected error:', err.message);
            }
            throw err;
        });
    }
}